import { useQuery } from '@tanstack/react-query';
import { useUser } from '@/hooks/useUser';
import { queryFn } from './queryFn';

export const getQueryKey = (
  companyId?: string
): [string, string | undefined] => ['COMPANY_NOTES', companyId?.toLowerCase()];

export const useCompanyNotes = (companyId?: string) => {
  const { data: user } = useUser();
  return useQuery({
    queryKey: getQueryKey(companyId),
    queryFn,
    enabled: user.loggedIn && !!companyId,
    staleTime: 3600000,
    retry: 1,
  });
};
